(function() {
  const section = document.querySelector('#shopify-section-template--19229755932771__divider_ggETLW');
  if (!section) return;

  section.style.position = 'relative';
  section.style.overflow = 'hidden';
  section.style.display = 'block';
  section.style.minHeight = '80px';

  Array.from(section.children).forEach(c => { if (c.tagName !== 'CANVAS') c.style.display = 'none'; });

  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.min.js';
  script.onload = initScene;
  document.head.appendChild(script);

  function initScene() {
    const THREE = window.THREE;
    let W = section.offsetWidth;
    let H = section.offsetHeight || 180;

    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setClearColor(0x080604, 1);
    renderer.setSize(W, H);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.3;
    renderer.domElement.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;display:block;';
    section.insertBefore(renderer.domElement, section.firstChild);

    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0x080604);
    scene.fog = new THREE.FogExp2(0x0a0705, 0.042);

    // KAMERA
    const camera = new THREE.PerspectiveCamera(38, W / H, 0.01, 80);
    camera.position.set(0, 1.0, 4.5);
    camera.lookAt(0, 0.8, 0);

    // IŞIKLAR
    scene.add(new THREE.AmbientLight(0xffe8c0, 0.18));

    const mainSpot = new THREE.SpotLight(0xffb830, 6.0, 22, Math.PI / 5.5, 0.35, 1.1);
    mainSpot.position.set(1, 10, 3);
    mainSpot.castShadow = true;
    mainSpot.shadow.mapSize.width = 2048;
    mainSpot.shadow.mapSize.height = 2048;
    mainSpot.shadow.bias = -0.001;
    scene.add(mainSpot);
    scene.add(mainSpot.target);

    const fillLight = new THREE.PointLight(0xff8820, 0.6, 15);
    fillLight.position.set(-7, 2, 1);
    scene.add(fillLight);

    const rimLight = new THREE.DirectionalLight(0x2244aa, 0.35);
    rimLight.position.set(6, 3, -5);
    scene.add(rimLight);

    const groundBounce = new THREE.PointLight(0x7a4a10, 0.4, 8);
    groundBounce.position.set(0, -3, 0);
    scene.add(groundBounce);

    // ARKA PLAN — koyu ahşap zemin + karanlık duvar
    const floorGeo = new THREE.PlaneGeometry(40, 40);
    const floorMat = new THREE.MeshStandardMaterial({ color: 0x1a0e06, roughness: 0.85, metalness: 0.05 });
    const floor = new THREE.Mesh(floorGeo, floorMat);
    floor.rotation.x = -Math.PI / 2;
    floor.position.y = -2.5;
    floor.receiveShadow = true;
    scene.add(floor);

    for (let i = -8; i <= 8; i++) {
      const lineGeo = new THREE.PlaneGeometry(0.012, 40);
      const lineMat = new THREE.MeshStandardMaterial({ color: 0x0d0702, roughness: 1.0 });
      const line = new THREE.Mesh(lineGeo, lineMat);
      line.rotation.x = -Math.PI / 2;
      line.position.set(i * 0.55, -2.49, 0);
      scene.add(line);
    }

    const wallGeo = new THREE.PlaneGeometry(40, 20);
    const wallMat = new THREE.MeshStandardMaterial({ color: 0x080604, roughness: 0.95, metalness: 0.0 });
    const wall = new THREE.Mesh(wallGeo, wallMat);
    wall.position.set(0, 5, -12);
    wall.receiveShadow = true;
    scene.add(wall);

    const haloGeo = new THREE.PlaneGeometry(12, 4);
    const haloMat = new THREE.MeshStandardMaterial({
      color: 0x3a1f08, roughness: 1.0, metalness: 0,
      transparent: true, opacity: 0.18,
      emissive: new THREE.Color(0x7a3a08), emissiveIntensity: 0.3
    });
    const halo = new THREE.Mesh(haloGeo, haloMat);
    halo.position.set(0, 6, -11.5);
    scene.add(halo);

    // KASNAK
    const kasnakDis = 5.0;
    const kasnakIc = 3.8;
    const kasnakK = 0.58;

    const ringShape = new THREE.Shape();
    ringShape.absarc(0, 0, kasnakDis, 0, Math.PI * 2, false);
    const holeShape = new THREE.Path();
    holeShape.absarc(0, 0, kasnakIc, 0, Math.PI * 2, true);
    ringShape.holes.push(holeShape);

    const kasnakGeo = new THREE.ExtrudeGeometry(ringShape, {
      depth: kasnakK, bevelEnabled: true,
      bevelThickness: 0.06, bevelSize: 0.05, bevelSegments: 5
    });
    kasnakGeo.rotateX(-Math.PI / 2);

    const mdfTopMat = new THREE.MeshStandardMaterial({ color: 0xC28A42, roughness: 0.92, metalness: 0.0 });
    const mdfSideMat = new THREE.MeshStandardMaterial({ color: 0x9A6428, roughness: 0.95, metalness: 0.0 });
    const kasnak = new THREE.Mesh(kasnakGeo, [mdfTopMat, mdfSideMat]);
    kasnak.receiveShadow = true;
    kasnak.castShadow = true;
    scene.add(kasnak);

    // MDF tahta lifi
    for (let i = 0; i < 14; i++) {
      const r = kasnakIc + (kasnakDis - kasnakIc) * (0.08 + i * 0.065);
      const arcStart = (i * 1.3) % (Math.PI * 2);
      const arcLen = (0.3 + (i % 3) * 0.18) * Math.PI;
      const grainGeo = new THREE.TorusGeometry(r, 0.005 + (i % 3) * 0.003, 3, 40, arcLen);
      const d = 0.55 + (i % 4) * 0.12;
      const grainMat = new THREE.MeshStandardMaterial({
        color: new THREE.Color(d * 0.52, d * 0.30, d * 0.10), roughness: 1.0, metalness: 0
      });
      const grain = new THREE.Mesh(grainGeo, grainMat);
      grain.rotation.x = -Math.PI / 2;
      grain.rotation.z = arcStart;
      grain.position.y = kasnakK + 0.001;
      scene.add(grain);
    }

    // ÇİVİLER
    const nailCount = 20;
    const nailPositions = [];
    const nailR = (kasnakDis + kasnakIc) / 2;
    const nailY = kasnakK + 0.88;

    const nailBodyMat = new THREE.MeshStandardMaterial({ color: 0x8B6018, metalness: 0.93, roughness: 0.20 });
    const nailHeadMat = new THREE.MeshStandardMaterial({ color: 0xE8BF38, metalness: 0.99, roughness: 0.03 });
    const nailConeMat = new THREE.MeshStandardMaterial({ color: 0x6A4510, metalness: 0.88, roughness: 0.30 });

    for (let i = 0; i < nailCount; i++) {
      const angle = (i / nailCount) * Math.PI * 2;
      const x = Math.cos(angle) * nailR;
      const z = Math.sin(angle) * nailR;
      nailPositions.push({ x, z });

      const cone = new THREE.Mesh(new THREE.CylinderGeometry(0.04, 0.005, 0.28, 10), nailConeMat);
      cone.position.set(x, kasnakK + 0.04, z);
      scene.add(cone);

      const body = new THREE.Mesh(new THREE.CylinderGeometry(0.062, 0.052, 0.82, 12), nailBodyMat);
      body.position.set(x, kasnakK + 0.50, z);
      body.castShadow = true;
      scene.add(body);

      const neck = new THREE.Mesh(new THREE.CylinderGeometry(0.068, 0.062, 0.06, 12), nailBodyMat);
      neck.position.set(x, kasnakK + 0.88, z);
      scene.add(neck);

      const head = new THREE.Mesh(new THREE.CylinderGeometry(0.155, 0.155, 0.052, 14), nailHeadMat);
      head.position.set(x, nailY, z);
      head.castShadow = true;
      scene.add(head);

      const rim = new THREE.Mesh(new THREE.TorusGeometry(0.135, 0.014, 8, 18), nailHeadMat);
      rim.rotation.x = Math.PI / 2;
      rim.position.set(x, nailY, z);
      scene.add(rim);
    }

    // İP UÇU IŞIKLARI
    const tipLight = new THREE.PointLight(0xffdd44, 6.0, 1.6);
    scene.add(tipLight);
    const haloLight = new THREE.PointLight(0xff8800, 2.5, 5.0);
    scene.add(haloLight);

    // ÇAPRAZ DESEN
    function buildPattern() {
      const step = Math.floor(nailCount * 0.38);
      const pattern = [];
      let cur = 0;
      const seen = new Set();
      while (!seen.has(cur)) { pattern.push(cur); seen.add(cur); cur = (cur + step) % nailCount; }
      pattern.push(pattern[0]);
      return pattern;
    }

    const stringPattern = buildPattern();
    let threadMesh = null;
    let t = 0;
    let camPosX = 0, camPosY = 1.0, camPosZ = 4.5;
    let camLookX = 0, camLookY = 0.8, camLookZ = 0;

    function buildThread() {
      if (threadMesh) { scene.remove(threadMesh); threadMesh.geometry.dispose(); threadMesh = null; }

      const totalSegs = stringPattern.length - 1;
      const globalT = t * totalSegs;
      const segIdx = Math.min(Math.floor(globalT), totalSegs - 1);
      const frac = globalT - segIdx;
      const points = [];

      for (let i = 0; i < segIdx; i++) {
        const a = nailPositions[stringPattern[i]];
        const b = nailPositions[stringPattern[i + 1]];
        for (let s = 0; s <= 30; s++) {
          const p = s / 30;
          points.push(new THREE.Vector3(
            a.x + (b.x - a.x) * p,
            nailY + Math.sin(p * Math.PI) * 0.07,
            a.z + (b.z - a.z) * p
          ));
        }
      }

      const aN = nailPositions[stringPattern[segIdx]];
      const bN = nailPositions[stringPattern[Math.min(segIdx + 1, totalSegs)]];
      for (let s = 0; s <= Math.round(frac * 30); s++) {
        const p = (s / 30) * frac;
        points.push(new THREE.Vector3(
          aN.x + (bN.x - aN.x) * p,
          nailY + Math.sin((frac > 0.01 ? p / frac : p) * Math.PI) * 0.07 * frac,
          aN.z + (bN.z - aN.z) * p
        ));
      }

      const tipX = aN.x + (bN.x - aN.x) * frac;
      const tipZ = aN.z + (bN.z - aN.z) * frac;
      tipLight.position.set(tipX, nailY + 0.2, tipZ);
      haloLight.position.set(tipX, nailY, tipZ);
      mainSpot.target.position.set(tipX * 0.15, 0, tipZ * 0.15);
      mainSpot.target.updateMatrixWorld();

      const tCamX = tipX * 0.82;
      const tCamZ = tipZ * 0.82 + 2.0;
      const tCamY = nailY + 0.55;
      camPosX += (tCamX - camPosX) * 0.07;
      camPosY += (tCamY - camPosY) * 0.05;
      camPosZ += (tCamZ - camPosZ) * 0.07;
      camLookX += (tipX - camLookX) * 0.08;
      camLookY += (nailY - camLookY) * 0.06;
      camLookZ += (tipZ - camLookZ) * 0.08;
      camera.position.set(camPosX, camPosY, camPosZ);
      camera.lookAt(camLookX, camLookY, camLookZ);

      if (points.length < 2) return;
      try {
        const curve = new THREE.CatmullRomCurve3(points);
        const geo = new THREE.TubeGeometry(curve, points.length * 2, 0.04, 10, false);
        const mat = new THREE.MeshStandardMaterial({ color: 0x060404, roughness: 0.78, metalness: 0.06 });
        threadMesh = new THREE.Mesh(geo, mat);
        threadMesh.castShadow = true;
        scene.add(threadMesh);
      } catch(e) {}
    }

    new ResizeObserver(() => {
      W = section.offsetWidth;
      H = section.offsetHeight || 180;
      renderer.setSize(W, H);
      camera.aspect = W / H;
      camera.updateProjectionMatrix();
    }).observe(section);

    function animate() {
      requestAnimationFrame(animate);
      t += 0.0007;
      if (t >= 1) t = 0;
      buildThread();
      renderer.render(scene, camera);
    }
    animate();
  }
})();
